<template>
  <div>
    <div class="banner">
      <el-image :src="image.url"/>
    </div>
    <div style="margin-top: 150px">
      <div class="lmtit">企业介绍</div>
      <div class="lmxian"></div>
      <Enterprise/>
    </div>
    <div>
      <div class="lmtit">专利证书</div>
      <div class="lmxian"></div>
      <Honor/>
    </div>
    <div>
      <div class="lmtit">ISO认证</div>
      <div class="lmxian"></div>
      <ISO/>
    </div>
    <div>
      <div class="lmtit">企业认证</div>
      <div class="lmxian"></div>
      <Authority/>
    </div>
    <div>
      <div class="lmtit">软件著作权</div>
      <div class="lmxian"></div>
      <demo/>
    </div>
  </div>
</template>

<script>
import demo from '../../components/demo'
import Enterprise from '../../components/main/Enterprise'
import ISO from '../../components/about/ISO'
import Honor from '../../components/about/Honor'
import Authority from '../../components/about/Authority'

export default {
  name: 'EnterprisePage',
  components: {
    demo,
    Enterprise,
    ISO,
    Honor,
    Authority
  },
  data () {
    return {
      image: { url: require('../../assets/images/about/banner/关于我们banner.png') }
    }
  }
}
</script>

<style scoped>
.lmtit {
  font-size: 30px;
  color: #333;
  margin: 50px 0 10px;
  text-align: center;
}

.lmxian {
  height: 1px;
  width: 60px;
  background: #287ab6;
  margin: 0 auto 20px;
}
</style>
